import React from "react";

const IconChevronRight = (props) => {
  return (
    <svg width={props.width ?? "22"} height={props.height ?? "22"} viewBox="0 0 8.23 14.459" {...props}>
      <path
        d="M11.63,0,5.815,5.815,0,0"
        transform="translate(1.414 13.045) rotate(-90)"
        fill="none"
        stroke={props.color ?? "#000"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IconChevronRight;
